import socketIO from 'socket.io-client'
import { useEffect, useState, useMemo } from 'react'
import { getAuthToken } from '../helper/storage'
import { useLocation } from 'react-router-dom'

export const useSocketConnection = (chatRoomId) => {
  const location = useLocation()
  const [socketConnection, setSocketConnection] = useState(false)
  const [messages, setMessages] = useState([])
  const socket = useMemo(() => {
    return socketIO(`${process.env.REACT_APP_SOCKET_URL}/chat?chatRoomId=${chatRoomId}`, {
      extraHeaders: {
        Authorization: getAuthToken()
      }
    })
  }, [chatRoomId])

  const socketIsTyping = (name) => {
    console.log('> User Typing', name)
  }

  const handleDisconnect = () => {
    socket.disconnect()
    socket.on('disconnect', () => {
      console.log('> Disconnected to server')
      setSocketConnection(false)
    })
  }
  useEffect(() => {
    return () => handleDisconnect()
  }, [])
  useEffect(() => {
    if (location?.pathname?.split('/')?.includes('chat') && !socketConnection) {
      const handleConnect = () => {
        console.log('> Connected to server')
        setSocketConnection(true)
      }
      if (socket) {
        socket.on('connect', handleConnect)
      }
    }
  }, [socket, location, socketConnection])

  useEffect(() => {
    const handleIsOnline = () => {
      console.log('> User Online')
      socket.emit('join_room')
      socket.emit('chat_list', { chatRoomId })
    }

    const handleMessages = (response) => {
      console.log('> Messages received')
      setMessages(response)
    }

    const handleReloadChatList = () => {
      console.log('> Reload Chat called')
      socket.emit('chat_list', {
        chatRoomId: chatRoomId
      })
    }
    if (socket) {
      socket.on('is_online', handleIsOnline)
      socket.on('messages', handleMessages)
      socket.on('reload_chat_list', handleReloadChatList)
      socket.on('is_user_typing', socketIsTyping)
    }
    return () => {
      socket.off('is_online', handleIsOnline)
      socket.off('messages', handleMessages)
      socket.off('reload_chat_list', handleReloadChatList)
      socket.off('is_user_typing', socketIsTyping)
    }
  }, [socketConnection])

  return {
    messages,
    handleDisconnect
  }
}
